import React, { useEffect } from 'react';
import { usePDF, Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';
import ToggleButton from '@mui/material/ToggleButton';

import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";

import Logo from '../../assets/images/erColor.png';
import Fuente from '../../assets/fonts/open-sans.ttf';

Font.register({
    family: 'Open Sans',
    src: Fuente
});

// Create styles
const styles = StyleSheet.create({
    page: {
        margin: '0cm 0cm',
    },
    section: {
        margin: '1cm 1cm 1cm',
    },
    header: {
        position: 'fixed',
        top: '0cm',
        left: '0cm',
        right: '0cm',
        height: '2cm',
        paddingLeft: '30px',
        paddingRight: '30px',
        marginBottom: '10px',
        border: '3px solid black',
    },
    recuadro: {
        border: '1px solid black',
        padding: '10px',
        marginBottom: '1em'
    },

    texto: {
        fontSize: '9px',
    },
    texto_fecha: {
        fontSize: '11px',
        textAlign: 'right',
        marginTop: '10px',
        color: 'grey',
    },
    texto_fecha_recuadro: {
        fontSize: '11px',
        textAlign: 'center',
        marginTop: '10px',
        color: 'grey',
    },
    texto_negrita: {
        fontSize: 14,
        fontWeight: 'bold'
    },
    texto_oyd: {
        fontSize: 11,
        fontWeight: 'bold'
    },
    texto_negrita_encabezado: {
        fontSize: 16,
        fontWeight: 'bold',
        textAlign: 'center',
        marginTop: '-20px',
        textTransform: 'uppercase'
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 9,
        bottom: 10,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey',
    },
    pageNumber2: {
        position: 'absolute',
        fontSize: 9,
        bottom: 10,
        left: 0,
        right: 30,
        textAlign: 'right',
        color: 'grey',
    },

    table: {
        width: '100%',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1px solid #EEE',
        paddingTop: 8,
        paddingBottom: 8,
        fontSize: 8,
        marginLeft: '1cm',
        marginRight: '1cm'
    },
    headert: {
        borderTop: 'none',
        backgroundColor: 'black',
        color: 'white',
        textAlign: 'center'
    },
    bold: {
        fontWeight: 'bold',
    },
    // So Declarative and unDRY 👌
    row1: {
        width: '10%',
        textAlign: 'center'
    },
    row2: {
        width: '30%',
        textAlign: 'center'
    },
    row3: {
        width: '10%',
        textAlign: 'center'
    },
    row4: {
        width: '20%',
        textAlign: 'center'
    },
    row5: {
        width: '20%',
        textAlign: 'center'
    },
    row6: {
        width: '10%',
        textAlign: 'center'
    },
    row1d: {
        width: '10%',
        textAlign: 'center'
    },
    row2d: {
        width: '30%',
        textAlign: 'left'
    },
    row3d: {
        width: '10%',
        textAlign: 'center'
    },
    row4d: {
        width: '20%',
        textAlign: 'left'
    },
    row5d: {
        width: '20%',
        textAlign: 'center'
    },
    row6d: {
        width: '10%',
        textAlign: 'center'
    },
    footer: {
      margin: '1cm',
    }
});
var today = new Date(),
    dateNow = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();

const Documento = (props) => (
    <Document>
        <Page size="A4" style={styles.page} orientation='landscape'>
            <View style={styles.section} fixed>
                <View style={styles.header}>
                    <Image
                        style={{ marginLeft: '10px', width: '4cm', marginTop: '10px' }}
                        src={Logo}
                    />
                    {props.tipoTramite === "expediente" ?
                        <Text style={styles.texto_negrita_encabezado}>LISTADO DE EXPEDIENTES ARCHIVADOS</Text> :
                        <Text style={styles.texto_negrita_encabezado}>LISTADO DE TRAMITES INTERNOS ARCHIVADOS</Text>
                    }
                </View>
                <View>
                    <View style={styles.recuadro}>
                        <Text style={styles.texto_oyd}><p style={styles.texto_negrita}><b style={styles.bold}>Fechas: </b></p>{props.fechas}</Text>
                    </View>
                </View>
            </View>
            <View style={styles.table}>
                <View style={[styles.row, styles.bold, styles.headert]} fixed>
                    {props.tipoTramite === "expediente" ?
                        <Text style={styles.row1}>Expediente</Text> :
                        <Text style={styles.row1}>Tramite int.</Text>
                    }
                    <Text style={styles.row2}>Asunto</Text>
                    <Text style={styles.row3}>Fecha de archivo</Text>
                    <Text style={styles.row4}>Orgnismo que archivó</Text>
                    <Text style={styles.row5}>Ubicación</Text>
                    <Text style={styles.row6}>Vigente</Text>

                </View>
                {props.datos.map((dato, indice) => (
                    <View key={indice} style={styles.row} wrap={false}>
                        {props.tipoTramite === "expediente" ?
                            <Text style={styles.texto, styles.row1d}>{dato.expediente}</Text> :
                            <Text style={styles.texto, styles.row1d}>{dato.tramiteInterno}</Text>
                        }
                        <Text style={styles.texto, styles.row2d}>{dato.asunto}</Text>
                        <Text style={styles.texto, styles.row3d}>{dato.fechaArchivoParaExcel}</Text>
                        <Text style={styles.texto, styles.row4d}>{dato.descOrgArchCompleta}</Text>
                        <Text style={styles.texto, styles.row5d}>{dato.ubicacion}</Text>
                        <Text style={styles.texto, styles.row6d}>{dato.vigente}</Text>
                    </View>
                ))}
            </View>
            <View style={styles.footer} fixed>
                <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                    `Página ${pageNumber} de ${totalPages}`
                )} />
                <Text style={styles.pageNumber2} render={({ pageNumber, totalPages }) => (
                    `Impresión ${dateNow}`
                )} />
            </View>
        </Page>

    </Document>
);

const ReporteArchivados = (props) => {
    const [instance, updateInstance] = usePDF({ document: <Documento datos={props.datos} fechas={props.fechas} tipoTramite={props.tipoTramite} /> });

    useEffect(() => {
        if (!instance.loading && props.datos.length !== 0 && props.datos.length <= 300) {
            window.open(instance.url, '', 'toolbar=yes, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=900, top=10');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [instance.loading])

    return (
        <ToggleButton
            value="imprimir"
            title="Imprimir listado"
            disabled={(props.datos.length === 0 || props.datos.length > 300) || instance.loading}
            onClick={updateInstance}
            sx={{ border: 0, "&.Mui-disabled": { border: 0, } }}
        >
            <PrintOutlinedIcon />
        </ToggleButton>
    );
};

export default ReporteArchivados;